import { memo } from "react";

import Button from "@mui/material/Button";

import { useFindingStore, Finding, FindingState } from "stores/FindingStore";

import { notifyError, notifySuccess } from "utility/notify";

// -----------------------------------------------------------------------------

const OrganizationFindingDetailsAcknowledge = memo(
  function OrganizationFindingDetailsAcknowledge({
    finding,
  }: OrganizationFindingDetailsAcknowledgeProps): JSX.Element {
    const [, actions] = useFindingStore();

    const acknowledgeFinding = () => {
      actions.updateState(
        finding.uuid,
        FindingState.Acknowledged,
        "acknowledge",
        (res: any) =>
          res.status === 200
            ? notifySuccess("The finding was acknowledged")
            : notifyError("Failed to acknowledge the finding")
      );
    };

    //
    return (
      <Button variant="contained" size="small" onClick={acknowledgeFinding}>
        Acknowledge
      </Button>
    );
  }
);

export default OrganizationFindingDetailsAcknowledge;

// -----------------------------------------------------------------------------

interface OrganizationFindingDetailsAcknowledgeProps {
  finding: Finding;
}
